import React, {useMemo} from 'react';

import {AlertTypeDTO} from 'kashable-mobile-common';

import {
    BankruptcyIcon,
    DelinquentAccountIcon,
    FraudAlertIcon,
    ImprovedAccountIcon,
    NewAccountIcon,
    NewEmploymentIcon,
    NewInquiryIcon,
    NewPublicRecordIcon,
} from '../../constants/Icons';

interface AlertIconProps {
    type: AlertTypeDTO.CreditMonitoringAlertType;
}

export const AlertIcon = ({type}: AlertIconProps) => {
    return useMemo(() => {
        switch (type) {
            case AlertTypeDTO.CreditMonitoringAlertType.NEW_ACCOUNT:
                return <NewAccountIcon />;
            case AlertTypeDTO.CreditMonitoringAlertType.NEW_EMPLOYMENT:
                return <NewEmploymentIcon />;

            case AlertTypeDTO.CreditMonitoringAlertType.NEW_ADDRESS:
                return <NewAccountIcon />;

            case AlertTypeDTO.CreditMonitoringAlertType.NEW_PUBLIC_RECORD:
                return <NewPublicRecordIcon />;

            case AlertTypeDTO.CreditMonitoringAlertType.NEW_INQUIRY:
                return <NewInquiryIcon />;

            case AlertTypeDTO.CreditMonitoringAlertType.IMPROVED_ACCOUNT:
                return <ImprovedAccountIcon />;

            case AlertTypeDTO.CreditMonitoringAlertType.DELINQUENT_ACCOUNT:
                return <DelinquentAccountIcon />;

            case AlertTypeDTO.CreditMonitoringAlertType.BANKRUPTCY:
                return <BankruptcyIcon />;

            case AlertTypeDTO.CreditMonitoringAlertType.FRAUD_ALERT:
                return <FraudAlertIcon />;
            default:
                return <NewEmploymentIcon />;
        }
    }, [type]);
};
